var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSharea(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#00E2A4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_196342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1001 18.1633C29.0643 16.6828 29.0762 14.8088 27.645 13.6657C26.2613 12.5597 24.2455 12.4006 22.3489 12.363C21.4782 12.344 20.7353 12.3347 19.9925 12.3347C19.2497 12.3347 18.5067 12.344 17.636 12.363C15.7514 12.4006 13.7236 12.5598 12.34 13.6657C10.9087 14.818 10.9206 16.6921 10.8848 18.1725V21.8366C10.9206 23.3171 10.9087 25.1911 12.34 26.3342C13.7237 27.4402 15.7395 27.5993 17.636 27.6369C18.5067 27.6555 19.2496 27.6652 19.9925 27.6652C20.7354 27.6652 21.4782 27.6554 22.3489 27.6369C24.2335 27.5993 26.2613 27.4401 27.645 26.3342C29.0762 25.1911 29.0643 23.3171 29.1001 21.8366C29.1121 21.2272 29.124 20.6091 29.1121 19.9997C29.1121 19.3908 29.1121 18.7819 29.1001 18.1633ZM23.289 20.0095C23.143 20.1531 22.9526 20.2253 22.7621 20.2253C22.5687 20.2253 22.3749 20.1511 22.2284 20.0017L20.6553 18.4079L20.6688 22.8835C20.6703 23.2976 20.3353 23.6345 19.9212 23.6355H19.9188C19.5057 23.6355 19.1703 23.3015 19.1688 22.8875L19.1552 18.3938L17.5585 20.0017C17.2675 20.2986 16.7919 20.2986 16.498 20.0095C16.2031 19.7185 16.2001 19.2429 16.4912 18.949L18.8183 16.5906C19.1049 16.3006 19.4868 16.1414 19.8935 16.1414C20.3002 16.1414 20.6821 16.3006 20.9677 16.5896L23.2958 18.949C23.5868 19.2429 23.5839 19.7185 23.289 20.0095Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_196342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharea);
export default __webpack_public_path__ + "static/media/sharea.869b10683d62c837f0585189aa42c115.svg";
export { ForwardRef as ReactComponent };